import { render, staticRenderFns } from "./gridmanagers.vue?vue&type=template&id=4ad80394"
import script from "./gridmanagers.vue?vue&type=script&lang=js"
export * from "./gridmanagers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports